import type {
	CommandConstructor,
	CommandProperties,
	CommandResult,
} from '@atlassian/rovo-content-bridge-api/command';

import type { ICommandHandler, PassThroughCommandProps } from '../command-handlers/command-handler';

export interface ICommandManager {
	/**
	 * Adds a command handler to the command manager.
	 *
	 * @param command - The command constructor
	 * @param handler - The command handler
	 * @returns The command manager
	 */
	addCommandHandler: <
		P extends CommandProperties = CommandProperties,
		R extends CommandResult = CommandResult,
	>(
		command: CommandConstructor<P, R>,
		handler: ICommandHandler<P, R>,
	) => ICommandManager;

	/**
	 * Adds default command handlers to the command manager.
	 *
	 * @returns The command manager
	 */
	addDefaultCommandHandlers: () => ICommandManager;

	/**
	 * The command props passed through to the command handlers.
	 */
	readonly commandProps: PassThroughCommandProps;
}

export type AddCommandHandlersFn = (params: { commandManager: ICommandManager }) => void;

/**
 * The key for the AIFC ADF update command.
 */
export const AIFC_ADF_UPDATE_KEY = 'aifc-adf-update' as const;

/**
 * The key for the dynamic UI create command.
 */
export const DYNAMIC_UI_CREATE_KEY = 'dynamic-ui-create' as const;